import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_RecoverySuppPlan2023 = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_RecoverySuppPlan2023' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Recovery Support Plan</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ID Number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' name='txtName' id='txtName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' name='txtIdNumber' id='txtIdNumber' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Need Statements(s) from Initial Assessment and ISP</span>
                    <textarea id='txtNeedStatements' name='txtNeedStatements' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Long Term Goal(s) from ISP</span>
                    <textarea id='txtLongTerm' name='txtLongTerm' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Short Term Goals</span>
                    <textarea id='txtShortTerm' name='txtShortTerm' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Strengths to Draw Upon (from ISP)</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Barriers which Interfere (from ISP)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' name='txtStrengthsDraw' id='txtStrengthsDraw' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' name='txtBarriers' id='txtBarriers' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Objectives </span>
                    <span className='small'>(what you hope will change for the person as a result of service)</span>
                    <textarea id='txtObjectives' name='txtObjectives' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Strategies </span>
                    <span className='small'>(actions by staff, family, other natural supports to assist in achieving specific objective)</span>
                    <textarea id='txtStrategies' name='txtStrategies' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'></td>
                        <td className='signature w-125'></td>
                        <td className='signature w-250'></td>
                        <td className='signature w-125'></td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Person Receiving Services</td>
                        <td className='small w-125'>Date</td>
                        <td className='small w-250'>Parent/Legal Guardian</td>
                        <td className='small w-125'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-250'></td>
                        <td className='signature w-125'></td>
                        <td className='signature w-250'></td>
                        <td className='signature w-125'></td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Direct Service Provider</td>
                        <td className='small w-125'>Date</td>
                        <td className='small w-250'>Direct Service Provider</td>
                        <td className='small w-125'>Date</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











